<template>
  <v-container fluid class="pa-6">
    <v-row class="pl-6" style="display: block">
      <p class="headline font-weight-bold wemodo-fig--text mb-0">
        Cours collectifs en replay
        <span class="wemodo-fig--text font-weight-regular"
          >({{ filteredWebinars.length }})</span
        >
      </p>
      <v-subheader class="pl-0">
        Aller plus loin sur votre projet grâce à nos cours collectifs animés et
        enregistés pour vous 📺
      </v-subheader>
    </v-row>
    <v-row class="px-3 pt-3 pb-5">
      <!-- <v-col cols="6"> -->

      <v-chip-group
      :show-arrows="$vuetify.breakpoint.xs"
        v-model="filters"
        active-class="wemodo-fig--back white--text"
        class="font-weight-medium"
      >
        <v-chip
          class="mx-1"
          :value="['Questions/Réponses', 'Vie de freelance', 'Marketing & Com', 'Graphisme', 'Web', 'SEO', 'Copywriting', 'Social media', 'IA', 'Code']"
          :class="allCatClass"
          :dark="allColor != ''"
        >
          <v-icon small left>mdi-eye</v-icon>
          Tous
        </v-chip>
        <v-chip class="mx-1" value="Questions/Réponses"> Questions/Réponses </v-chip>
        <v-chip class="mx-1" value="Vie de freelance"> Vie de freelance </v-chip>
        <v-chip class="mx-1" value="Marketing & Com"> Marketing & Com </v-chip>
        <v-chip class="mx-1" value="Graphisme"> Graphisme </v-chip>
        <v-chip class="mx-1" value="Web"> Web </v-chip>
        <v-chip class="mx-1" value="SEO"> SEO </v-chip>
        <v-chip class="mx-1" value="Copywriting"> Copywriting </v-chip>
        <v-chip class="mx-1" value="Social media"> Social media </v-chip>
        <v-chip class="mx-1" value="IA"> IA </v-chip>
        <v-chip class="mx-1" value="Code"> Code </v-chip>
      </v-chip-group>

      <!-- </v-col> -->
      <!-- <v-col>
        <v-text-field
          v-model="search"
          hide-details
          prepend-inner-icon="mdi-magnify"
          outlined
          background-color="white"
          color="blue accent-4"
          label="Chercher un webinar"
        ></v-text-field>
      </v-col> -->
    </v-row>
    <v-row justify="start">
      <v-col
        cols="12" md="4"
        v-for="(webinar, index) in filteredWebinars"
        :key="index"
        class="d-flex flex-column my-2"
      >
        <v-skeleton-loader
          type="card"
          :loading="loading"
          class="flex d-flex flex-column"
        >
          <v-hover v-slot="{ hover }">
            <v-card
              class="pa-2 flex d-flex flex-column dashboard-card"
              :to="{ name: 'webinar', params: { id: webinar.id } }"
              flat
            >
              <v-img :src="webinar.picture" max-height="200" class="rounded">
                <v-fade-transition>
                  <v-overlay v-if="hover" absolute>
                    <v-btn
                      fab
                      :to="{ name: 'webinar', params: { id: webinar.id } }"
                      class="wemodo-fig--back"
                      ><v-icon>mdi-play</v-icon></v-btn
                    >
                  </v-overlay>
                </v-fade-transition>
              </v-img>

              <v-card-subtitle class="font-weight-medium wemodo-fig--text pl-1">
                {{ webinar.title }}
              </v-card-subtitle>
              <v-row class="my-1" justify="start" align="start">
                <v-col class="pr-0">
                  <v-chip
                    small
                    style="background: white; color: #18093B"
                    color="#18093B"
                  >
                    <v-icon left small>mdi-calendar-month</v-icon>
                    {{
                      webinar.date.toDate().toLocaleDateString("fr-FR", {
                        weekday: "long",
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })
                    }}</v-chip
                  >
                </v-col>

                <v-col class="px-0">
                  <v-chip
                    small
                    style="background: white; color: #18093B"
                    color="#18093B"
                  >
                    <v-icon left small>mdi-timer-outline</v-icon
                    >{{ webinar.length }}</v-chip
                  >
                </v-col>
              </v-row>
              <v-row class="pt-4 pl-2">
                <v-col class="caption wemodo-fig--text" align-self="center">
                  <v-avatar size="30">
                    <v-img
                      :src="webinar.animator.pic"
                      v-if="webinar.animator.pic != ''"
                    ></v-img>
                    <v-icon v-else>mdi-account-circle</v-icon>
                  </v-avatar>
                  <span class="pl-2">{{ webinar.animator.name }}</span>
                </v-col>
                <v-col align-self="center">
                  <v-chip outlined small color="#18093B" label
                    ><v-icon left small>{{
                      getWebinarIcon(webinar.category)
                    }}</v-icon
                    >{{ webinar.category }}</v-chip
                  >
                </v-col>
              </v-row>
            </v-card>
          </v-hover>
        </v-skeleton-loader>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Webinars",
  data() {
    return {
      loading: true,
      filters: ['Questions/Réponses', 'Vie de freelance', 'Marketing & Com', 'Graphisme', 'Web', 'SEO', 'Copywriting', 'Social media', 'IA', 'Code'],
      search: "",
      initialFilters: [0, 1, 2],
    };
  },
  computed: {
    ...mapState(["webinars"]),
    filteredWebinars: function () {
      return this.webinars.filter((w) => this.filters.includes(w.category));
    },
    allColor: function () {
      let bool =
        this.filters.includes("Questions/Réponses") &&
        this.filters.includes("Vie de freelance") &&
        this.filters.includes("Marketing & Com") &&
        this.filters.includes("Graphisme") &&
        this.filters.includes("Web") &&
        this.filters.includes("SEO") &&
        this.filters.includes("Copywriting") &&
        this.filters.includes("Social media") &&
        this.filters.includes("IA") &&
        this.filters.includes("Code")
      if (bool) {
        return "wemodo-fig--back white--text";
      } else {
        return "";
      }
    },
    allCatClass: function () {
      // let bool =
      //   this.filters.includes("Questions/Réponses") &&
      //   this.filters.includes("Vie de freelance") &&
      //   this.filters.includes("Marketing & Com") &&
      //   this.filters.includes("Graphisme") &&
      //   this.filters.includes("Web") &&
      //   this.filters.includes("SEO") &&
      //   this.filters.includes("Copywriting") &&
      //   this.filters.includes("Social media") &&
      //   this.filters.includes("IA") &&
      //   this.filters.includes("Code")
      if (this.filters.length === 10) {
        return "wemodo-fig--back white--text v-chip--active";
      } else {
        return "";
      }
    },
  },
  methods: {
    getWebinarIcon(cat) {
  switch (cat) {
    case "Questions/Réponses":
      return "mdi-frequently-asked-questions";
    case "Vie de freelance":
      return "mdi-briefcase";
    case "Marketing & Com":
      return "mdi-comment-outline";
    case "Graphisme":
      return "mdi-palette";
    case "Web":
      return "mdi-web";
    case "SEO":
      return "mdi-magnify";
    case "Copywriting":
      return "mdi-fountain-pen-tip";
    case "IA":
      return "mdi-robot";
    case "Code":
      return "mdi-code-tags";
    case "Social media":
      return "mdi-share-variant";
    default:
      return "";
  }
},
    toggle() {
      if (this.filters != [0, 1, 2, 3, 4]) {
        this.filters = [0, 1, 2, 3, 4];
      } else {
        this.filters = [];
      }
    },
    chipColor(cat) {
      if (cat === "SEO") {
        return "green accent-4";
      } else if (cat === "Communication") {
        return "orange accent-4";
      } else if (cat === "Marketing") {
        return "blue accent-4";
      } else if (cat === "Code") {
        return "#FCD004";
      }
    },
  },
  mounted() {
    this.$store.dispatch("setWebinars");
    setTimeout(() => {
      this.loading = false;
    }, 1200);
  },
};
</script>

<style>
</style>